import { MoreMenu } from 'components/MoreMenu';
import { Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';

import { InfoCardStyled, InfoCardFieldsStyled } from './InfoCard.styles';
import { InfoCardProps } from './types';

export const InfoCard = <MenuOptionValue extends string | number>({
  title,
  fields,
  chip,
  columnCount = 2,
  menuOptions,
  variant = 'default',
  onClick,
  onClickMenuOption,
}: InfoCardProps<MenuOptionValue>) => (
  <InfoCardStyled variant={variant}>
    <Stack
      alignItems="center"
      as="button"
      className="info-card-header"
      direction="row"
      spacing={16}
      onClick={onClick}
    >
      <Typography color="inherit" maxLine={2} variant="bodyMedium">
        {title}
      </Typography>

      {chip}

      <Stack
        alignItems="center"
        className="info-card-icons"
        direction="row"
        spacing={8}
      >
        {menuOptions && menuOptions.length > 0 && (
          <MoreMenu
            options={menuOptions}
            variant="horizontal"
            onClickOption={(option) => onClickMenuOption?.(option)}
          />
        )}
        <Icon.ArrowRight color="inherit" />
      </Stack>
    </Stack>

    <InfoCardFieldsStyled columnCount={columnCount}>
      {fields.map((field) => {
        const value =
          !field.value || typeof field.value === 'string' ? (
            <Typography
              className="ellipsisText"
              title={typeof field.value === 'string' ? field.value : undefined}
              variant="captionMedium"
            >
              {field.value || '—'}
            </Typography>
          ) : (
            field.value
          );

        return (
          <Stack key={field.label} spacing={4}>
            <Typography className="info-card-field-label" variant="small">
              {field.label}
            </Typography>
            {field.valueAdornment ? (
              <Stack alignItems="center" direction="row" spacing={4}>
                {value}
                {field.valueAdornment}
              </Stack>
            ) : (
              value
            )}
          </Stack>
        );
      })}
    </InfoCardFieldsStyled>
  </InfoCardStyled>
);
